import { colorContrasts } from "./constants";

/**
 * string has pattern rquired for mathjax rendering
 * @param {[string]} [str] [text value needs mathjax rendering]
 * @return {[boolean]} [if regex finds match for patter]
 */
export const hasMathJaxPattern = function( str ) {
    if(typeof str === 'string') {
        const mathJaxPattern = /(\${1,2})((?:\\.|[\s\S])*)\1/,
            found = window.hasOwnProperty('MathJax') && str.match(mathJaxPattern);
        if( found ) {
            // Additional check: exclude text that looks like currency or plain text with dollar signs
            const content = found[0].replace(/^\$+|\$+$/g, '');
            // If the content is just a number, currency amount, or plain text, don't treat as math
            if (/^\d+\.?\d*$/.test(content) || // Just numbers like $100, $50.00
                /^[a-zA-Z\s]+$/.test(content) || // Just letters and spaces like "millions of "
                content.length < 3 || // Very short content
                /^[^\\]*$/.test(content) && !/[_^]/.test(content) && content.length > 20) { // Long text without LaTeX commands, subscripts, or superscripts
                return false;
            }
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export function requireJrMode(mode) {
    return ['jr'].includes(mode);
}

export function getColorContrastsByMode(theme, mode) {
    if(requireJrMode(mode)) {
        return colorContrasts.find(_theme => _theme.value === theme).overridingValue || theme;
    } else {
        return theme;
    }
}

/**
 * animations
 */

const duration = 1000; // ms
const delay = 40; // ms

export const CardAnimation = (i) => `cardFadeIn ${duration}ms ease-out ${delay * (i+1)}ms forwards`;
